import { Button } from '@shared/components/shadcn';
import { routesCategoryMap } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { GamesFiltersType } from '../GamesFilter/GamesFilter';

type CategoryFilters = Pick<GamesFiltersType, 'gameProviders'>;

type CategoryDetailsButtonProps = {
  namespace: string;
  category?: string;
  buttonVariant?: 'secondary' | 'primary';
  linkTextOverride?: string;
  filters?: CategoryFilters;
};

function buildFilterQuery(filters: CategoryFilters): string {
  const params = new URLSearchParams();
  if (filters.gameProviders?.length) params.set('gameProviders', filters.gameProviders.join(','));
  const query = params.toString();
  return query ? `?${query}` : '';
}

function CategoryDetailsButton({ namespace, category = 'no-category', buttonVariant = 'secondary', linkTextOverride, filters }: CategoryDetailsButtonProps) {
  const t = useTranslations(namespace);

  const base = routesCategoryMap.get(`${namespace}.${category}`) ?? '/';
  const route = filters ? `${base}${buildFilterQuery(filters)}` : base;

  return (
    <Button variant={buttonVariant} size="s" asChild data-track-name="View All">
      <Link href={route} data-testid="view-all">
        {linkTextOverride ?? t('view_all')}
      </Link>
    </Button>
  );
}

export { CategoryDetailsButton };
